/**
 * Scenario service — OutpostForge frontend (CES standard)
 * Sandbox what-if scenarios (DynamoDB behind the backend; 503 in dev
 * triggers the localStorage fallback in scenarioStore).
 */

import type { SandboxState, Scenario } from '../sandbox';
import { http } from '../http';

export interface ListScenariosResponse {
  scenarios: Scenario[];
}

export const scenarioService = {
  async getScenarios(): Promise<ListScenariosResponse> {
    const response = await http.get<ListScenariosResponse>('/scenarios');
    return response.data;
  },

  async postScenario(body: { name: string; state: SandboxState }): Promise<Scenario> {
    const response = await http.post<Scenario>('/scenarios', body);
    return response.data;
  },

  async deleteScenario(id: string): Promise<void> {
    await http.delete(`/scenarios/${encodeURIComponent(id)}`);
  },
};

export type ScenarioService = typeof scenarioService;
